import md5 from 'js-md5'

const SocketTypePrefix = {
    docworks: 'docworks_',
    video: 'video_'
}

class SocketMessageMaker {

    static make(params) {
        const {
            user_id
        } = params
        const timestamp = new Date().getTime()
        const signature = md5(user_id + 'web' + 'docbooksockettokenvalue' + timestamp)
        return {
            signature,
            userid: user_id,
            platform: 'web',
            version: '1.0',
            timestamp,
            ...params
        }
    }

    static makes(params) {
        if (!params) return []
        return params.map(param => {
            return SocketMessageMaker.make(param)
        })
    }
}



export {
    SocketTypePrefix,
    SocketMessageMaker
}